import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  HStack,
  Checkbox,
  ModalFooter,
  Button,
  Box,
  Text,
  Center,
  Tooltip,
} from "@chakra-ui/react";
import React from "react";
import { MdDelete } from "react-icons/md";

const DeleteTrainerModal = ({
  isOpen,
  onClose,
  deletetrainer,
  each,
  opendeletetrainerAlert,
}: {
  isOpen: any;
  onClose: any;
  deletetrainer: any; // This function is called when the user confirms the deletion of trainer
  each: any;
  opendeletetrainerAlert: any;
}) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize={"22px"}>
            Delete Course/Program Trainers
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            {each?.trainers?.map((eachTrainer: any, ind: number) => (
              <HStack mb={"15px"} key={ind} justifyContent={"space-between"}>
                <Text fontSize={"15px"} fontWeight={"400"}>
                  {eachTrainer.name}
                </Text>
                <Tooltip label="Remove this trainer" aria-label="Remove this trainer">
                <Box
                  cursor={"pointer"}
                  onClick={() => {
                    opendeletetrainerAlert(eachTrainer.uuid, each.uuid);
                  }}
                >

                  <Center
                    border="1px solid"
                    borderRadius="10px"
                    borderColor="#E5E5E5"
                    width="30px"
                    height="30px"
                    cursor={"pointer"}
                    title="Remove this trainer"
                  >
                    <MdDelete color="red" />
                  </Center>
                </Box>
                </Tooltip>
              </HStack>
            ))}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DeleteTrainerModal;
